const ON_CHANGE_DEBOUNCE_TIMER = 5000; // 增加到 5 秒，避免 429 错误

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// CartRequestManager 已在 cart-request-manager.js 中定义
// 不要在这里重复定义，否则会覆盖完整版本

